module.exports = __webpack_public_path__ + "img/company-gray.36bc086b.svg";